const baseStyle = {
  border: 0,
  borderRadius: `lg`,
  color: `white`,
  fontFamily: `body`,
  fontWeight: `semibold`,
  py: 4,
  display: `inline-flex`,
  justifyContent: `center`,
  alignItems: `center`,
};

const sizes = {
  xs: {
    fontSize: `sm`,
    height: `auto`,
    p: 3,
  },
  sm: {
    fontSize: `md`,
    height: `auto`,
    px: 8,
    py: 3,
  },
  md: {
    height: `auto`,
    px: 10,
  },
  square: {
    height: 4,
    width: 4,
    p: 5,
  },
};

const variants = {
  solid: {
    background: `primary.base`,
    _hover: {
      background: `primary.darker`,
    },
    _active: {
      background: `primary.darker`,
    },
  },
  solidBlue: {
    background: `heading`,
    _hover: {
      background: `headingDarker`,
    },
    _active: {
      background: `headingDarker`,
    },
  },
  solidYellow: {
    background: `#F49D10`,
    _hover: {
      background: `#d68400`,
    },
    _active: {
      background: `#d68400`,
    },
  },
  outline: {
    background: `transparent`,
    border: `2px`,
    borderColor: `border`,
    color: `secondary`,
  },
  gray: {
    background: `gray.200`,
    color: `heading`,
    _hover: {
      background: `gray.300`,
    },
    _active: {
      background: `gray.300`,
    },
  },
  round: {
    background: `primary.base`,
    borderRadius: `100%`,
    _hover: {
      background: `primary.darker`,
    },
    _active: {
      background: `primary.darker`,
    },
  },
  outlineRed: {
    background: `transparent`,
    color: `primary.base`,
    border: `2px`,
    px: 8,
    py: 3,
    fontWeight: `600`,
    borderColor: `primary.base`,
    _hover: {
      background: `primary.base`,
      color: `white`,
    },
  },
  outlineBlue: {
    background: `transparent`,
    color: `heading`,
    border: `2px`,
    px: 8,
    py: 3,
    fontWeight: `600`,
    borderColor: `heading`,
  },
  smallOutlineRed: {
    background: `transparent`,
    border: `2px`,
    borderColor: `primary.base`,
    color: `primary.base`,
    padding: 1,
    fontWeight: `500`,
    _hover: {
      background: `primary.base`,
      color: `white`,
    },
  },
  smallOutlineBlue: {
    background: `transparent`,
    border: `2px`,
    borderColor: `secondary`,
    color: `secondary`,
    padding: 1,
    fontWeight: `500`,
    _hover: {
      background: `secondary`,
      color: `white`,
    },
  },
  blueProgress: {
    background: `heading`,
    color: `white`,
    border: `2px`,
    px: 8,
    py: 3,
    fontWeight: `600`,
    borderColor: `heading`,
    _hover: {
      background: `headingDarker`,
      color: `white`,
    },
  },
  redProgress: {
    background: `primary.base`,
    // _hover: {
    //   background: `primary.darker`,
    // },
    _active: {
      background: `primary.darker`,
    },
    px: 4,
    py: 0,
    height: `47px`,
    width: `270px`,
    m: 0,
  },
  lightBlue: {
    background: `lightBlue`,
    color: "white",
    height: `50px`,
    _hover: {
      background: `secondary`,
    },
    _active: {
      background: `secondary`,
    },
  },
  transparent: {
    background: `transparent`,
    color: "white",
    height: `50px`,
  },
};

export const Button = {
  baseStyle,
  sizes,
  variants,
};
